import DocumentGroup from "./DocumentGroup";

export default DocumentGroup;
